import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { AdsGETApiAuth } from "../../../Constant/api";
import { slugs } from "../../../Constant/slugs";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
const columns = [
  {
    id: 1,
    name: "id",
    selector: (row) => row.id,
    sortable: true,
    reorder: true,
  },
  {
    id: 31,
    name: "Title",
    selector: (row) => row.title.rendered,
    sortable: true,
    reorder: true,
  },
  {
    id: 32,
    name: "Exam Time",
    selector: (row) => row.meta.exam_time,
    sortable: true,
    reorder: true
  },
  {
    id: 32,
    name: "Date",
    selector: (row) => row.date.slice(0, 10),
    sortable: true,
    reorder: true
  },
  {
    id: 33,
    name: "Availability",
    selector: (row) => row.meta.available_unavailable,
    sortable: true,
    reorder: true,
    width: "150px"

  },
  {
    id: 34,
    name: "Type",
    selector: (row) => row.meta.exam_type,
    sortable: true,
    reorder: true
  },
  {
    id: 34,
    name: "Code",
    selector: (row) => row.meta.exam_code,
    sortable: true,
    reorder: true
  },
  {
    id: 3,
    name: "View",
    right: true,
    cell: (row) => <Link to={`${slugs.exam_2_details}${row.slug}`}>View</Link>,

  }
];
const typeArray = {
  "ubt": "UBT",
  "chapter-exam": "Chapter",
  "question-bank": "Question Bank",
  "weekly-test": "Weekly Test",
  "grammer-test": "Grammer Test"
}
export default function AllWeeklyExamAdmin() {
  const [Projects1, setProjects1] = React.useState([])
  const [CustomersList, setCustomersList] = React.useState([])
  const [Reload, setReload] = React.useState(false)
  const history = useHistory
  ()
  const location = useLocation()
  const GetAllProjects = (type) => {
    setReload(true)
    setProjects1([])
    AdsGETApiAuth({
      per_page: 100,
      _fields: "id,title,slug,date,meta.exam_code,meta.exam_time,meta.available_unavailable,meta.exam_type,meta.batch_name",
      "filter[meta_query][1][key]": "exam_type",
      "filter[meta_query][1][value][0]": `${typeArray[type]}`,
      "filter[meta_query][1][compare]": "=",
    }, slugs.db_slug_weekly_exam)
      .then((res) => {
        setProjects1(res.data)
        setCustomersList(res.data)
        console.log("done")
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
        setReload(false)
      })
  }
  var type = location.pathname.slice(slugs.all_exam_2.length + 1) == "" ? "weekly-test" : location.pathname.slice(slugs.all_exam_2.length + 1)
  useEffect(() => {
    // GetAllProjects()
    var type;
    type = location.pathname.slice(slugs.all_exam_2.length + 1) == "" ? "weekly-test" : location.pathname.slice(slugs.all_exam_2.length + 1)
    GetAllProjects(type)
    return history.listen((location) => {
      if (location.pathname.includes(slugs.all_exam_2)) {
        type = location.pathname.slice(slugs.all_exam_2.length + 1) == "" ? "weekly-test" : location.pathname.slice(slugs.all_exam_2.length + 1)
        window.scrollTo(0, 0)
        GetAllProjects(type)
      }
    })

  }, [])

  return (
    <div>
      <div className="row" style={{ padding: "30px 30px" }}>
        <div className="col-md-8 button">
          <h2>All Test</h2>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <a href="/">Dashboard</a> / All Test
        </div>
      </div>
      <a href={`${slugs.new_exam_2}/${type}`}>
        <div className="sign-in-button-4" style={{ width: "150px", margin: "10px" }}
          onClick={() => {

          }}
        >Add New Test</div>
      </a>
      <div style={{ backgroundColor: "#fff", padding: "10px", width: "97%", margin: "10px" }}>
        <DataTable
          columns={columns}
          data={CustomersList}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          striped
          // sortIcon={<SortIcon />}
          pagination
          selectableRows
        />
      </div>
      {Reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
    </div>
  )
}